export default "__VITE_ASSET__Akd6EMdc__"